<template>
	<div class="ss-content brilliantEHome-content">
		<div class="brilliantEHome__banner"></div>
		<ss-breadcrumb />
		<div class="ss-container">
			<div class="ss-type-box">
				<div class="ss-type__label">
					<img src="~@/assets/img/brilliantEHome/px-type.png" />
					培训类型
				</div>
				<div class="ss-type__text">
					<span v-for="(item, index) in typeList" @click="changeType(index)" :class="{'active': typeIndex === index}" :key="item.value">{{item.label}}</span>
				</div>
			</div>
			<div class="mt50">
				<ssTrainList :finish="finish_" :busy="busy_" :value="curData_" detailPath="/brilliantEHome/train/" />
				<ssNavigation v-if="pageTotal_ > pageSize" :total="pageTotal_" v-model="curPage" :size="pageSize" />
			</div>
		</div>
	</div>
</template>

<script>
	import ssTrainList from '@/components/ss-train-list/ss-train-list.vue'
	import listMixin from '@/mixins/list.js'
	export default {
		mixins: [ listMixin ],
		components:{
			ssTrainList
		},
		data() {
			return {
				pageSize: 12,
				typeList: [{
					value: 'jcpxsy,jcpxsf,jcpxms,jcpxlq,jcpxsl,jcpxfy,jcpxqt',
					label: '全部'
				}, {
					value: 'jcpxsy',
					label: '摄影'
				}, {
					value: 'jcpxsf',
					label: '书法'
				}, {
					value: 'jcpxms',
					label: '美术'
				}, {
					value: 'jcpxlq',
					label: '乐器'
				}, {
					value: 'jcpxsl',
					label: '声乐'
				}, {
					value: 'jcpxfy',
					label: '非遗'
				}, {
					value: 'jcpxqt',
					label: '其他'
				}]
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.brilliantEHome-content{
		padding-bottom: 70px;
		background-color: #fff;
		.brilliantEHome-list-box{
			margin-top: 50px;
		}
		.brilliantEHome__banner{
			background: url(~@/assets/img/brilliantEHome/banner.png) center center / 1920px auto no-repeat;
			height: 200px;
		}
	}
</style>
